import { render, staticRenderFns } from "./InputV2.vue?vue&type=template&id=0bb6b621&scoped=true&"
import script from "./InputV2.vue?vue&type=script&lang=ts&"
export * from "./InputV2.vue?vue&type=script&lang=ts&"
import style0 from "./InputV2.vue?vue&type=style&index=0&id=0bb6b621&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb6b621",
  null
  
)

export default component.exports